import { Controller } from "@hotwired/stimulus";

// Draws a signature with the finger or the mouse on a tablet or a phone,
// and keeps it as a PNG data URL in a hidden field (treasury plan, X2.5).
export default class extends Controller {
  static targets = ["canvas", "field", "submit"];

  connect() {
    this.pen = this.canvasTarget.getContext("2d");
    this.resize();
    this.pen.lineWidth = 2.5;
    this.pen.lineCap = "round";
    this.pen.strokeStyle = "#111";
    this.drawing = false;
    this.drawn = false;
    this.toggleSubmit();
  }

  resize() {
    const ratio = window.devicePixelRatio || 1;
    const { width, height } = this.canvasTarget.getBoundingClientRect();
    this.canvasTarget.width = width * ratio;
    this.canvasTarget.height = height * ratio;
    this.pen.scale(ratio, ratio);
  }

  start(event) {
    event.preventDefault();
    this.drawing = true;
    const { x, y } = this.point(event);
    this.pen.beginPath();
    this.pen.moveTo(x, y);
  }

  move(event) {
    if (!this.drawing) return;
    event.preventDefault();
    const { x, y } = this.point(event);
    this.pen.lineTo(x, y);
    this.pen.stroke();
    this.drawn = true;
  }

  end() {
    if (!this.drawing) return;
    this.drawing = false;
    this.fieldTarget.value = this.canvasTarget.toDataURL("image/png");
    this.toggleSubmit();
  }

  clear() {
    this.pen.clearRect(0, 0, this.canvasTarget.width, this.canvasTarget.height);
    this.fieldTarget.value = "";
    this.drawn = false;
    this.toggleSubmit();
  }

  point(event) {
    const rect = this.canvasTarget.getBoundingClientRect();
    const source = event.touches ? event.touches[0] : event;
    return { x: source.clientX - rect.left, y: source.clientY - rect.top };
  }

  toggleSubmit() {
    if (this.hasSubmitTarget) this.submitTarget.disabled = !this.drawn;
  }
}
